<h2 mat-dialog-title class="modal">{{title}}</h2>

<mat-dialog-content class="mat-typography">
    <div class="main-message">
        {{text}}
    </div>
    <div class="details-box" *ngIf="(extraText != null)">
        {{extraText}}
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button class="mat-raised-button mat-primary" (click)=acceptChange() cdkFocusInitial>Sim</button>
</mat-dialog-actions>